import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LoginService } from "@core/services";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-register-step-1",
  templateUrl: "./register-step-1.component.html",
  styleUrl: "./register-step-1.component.scss",
  standalone: true,
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RegisterStep1Component implements OnInit {
  mailAddress: string = "";

  constructor(
    private route: ActivatedRoute,
    private loginService: LoginService
  ) {}

  ngOnInit(): void {
    this.mailAddress = this.route.snapshot.queryParamMap.get("mailAddress") ?? "";
  }

  continueWithPasswordReset(): void {
    const queryParams: Record<string, string> = this.mailAddress
      ? { mailAddress: this.mailAddress }
      : {};
    const redirectState = JSON.stringify({ path: "/register-step-2", queryParams });

    this.loginService.resetPassword(this.mailAddress, redirectState);
  }
}
